var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrDashboardRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 33,
    viewBox: "0 0 63 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.8368V0.473969H40.4535V8.61003C39.7589 8.67262 39.0827 8.79906 38.4309 8.98344V8.56468H2.02268V30.8141H38.4309V30.3954C39.0827 30.5797 39.7589 30.7062 40.4535 30.7688V32.8368H0ZM38.4309 2.49665H2.02268V6.542H38.4309V2.49665ZM10.0936 11.4802L11.9938 10.7888L18.2199 27.8947L16.3197 28.59L10.0936 11.4802ZM6.06803 16.6554V14.6327H8.09071V16.6554H6.06803ZM6.06803 24.7461V22.7234H8.09071V24.7461H6.06803Z",
    fill: "#0BB7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2267 13.6214H29.3287",
    stroke: "#0BB7A7",
    strokeWidth: 2.02268,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2267 18.6781H26.2947",
    stroke: "#0BB7A7",
    strokeWidth: 2.02268,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2267 23.7348H29.3287",
    stroke: "#0BB7A7",
    strokeWidth: 2.02268,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_1042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0743 30.0556C38.1491 30.0556 36.2671 29.4847 34.6664 28.4151C33.0656 27.3455 31.8179 25.8252 31.0812 24.0466C30.3444 22.2679 30.1517 20.3107 30.5273 18.4224C30.9028 16.5342 31.8299 14.7997 33.1913 13.4384C34.5526 12.0771 36.2871 11.15 38.1753 10.7744C40.0635 10.3988 42.0208 10.5916 43.7994 11.3283C45.5781 12.0651 47.0984 13.3127 48.168 14.9135C49.2376 16.5143 49.8085 18.3962 49.8085 20.3215C49.8056 22.9022 48.7791 25.3765 46.9542 27.2013C45.1293 29.0262 42.6551 30.0527 40.0743 30.0556ZM40.0743 11.9779C38.4241 11.9779 36.811 12.4673 35.4389 13.3841C34.0668 14.3009 32.9974 15.604 32.3659 17.1285C31.7344 18.6531 31.5692 20.3307 31.8911 21.9492C32.2131 23.5677 33.0077 25.0544 34.1746 26.2212C35.3414 27.3881 36.8281 28.1828 38.4466 28.5047C40.0651 28.8266 41.7427 28.6614 43.2673 28.0299C44.7919 27.3984 46.0949 26.329 47.0117 24.9569C47.9285 23.5848 48.4179 21.9717 48.4179 20.3215C48.4154 18.1094 47.5355 15.9887 45.9713 14.4245C44.4072 12.8603 42.2864 11.9805 40.0743 11.9779Z",
    fill: "#0BB7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.514 16.8374L40.1166 19.4399L42.7056 16.8509C42.7628 16.79 42.8317 16.7413 42.9081 16.7077C42.9846 16.6741 43.0671 16.6563 43.1506 16.6554C43.3294 16.6554 43.5009 16.7264 43.6273 16.8529C43.7538 16.9793 43.8248 17.1508 43.8248 17.3296C43.8264 17.4123 43.811 17.4944 43.7797 17.5709C43.7484 17.6474 43.7018 17.7167 43.6428 17.7746L41.02 20.3636L43.6428 22.9864C43.7539 23.0951 43.819 23.2423 43.8248 23.3976C43.8248 23.5764 43.7538 23.7479 43.6273 23.8744C43.5009 24.0008 43.3294 24.0719 43.1506 24.0719C43.0646 24.0754 42.9789 24.0611 42.8988 24.0297C42.8187 23.9984 42.746 23.9508 42.6854 23.8898L40.1166 21.2873L37.5208 23.8831C37.4638 23.9419 37.3958 23.9889 37.3205 24.0213C37.2453 24.0537 37.1644 24.0709 37.0825 24.0719C36.9037 24.0719 36.7322 24.0008 36.6058 23.8744C36.4793 23.7479 36.4083 23.5764 36.4083 23.3976C36.4067 23.315 36.4221 23.2329 36.4534 23.1563C36.4847 23.0798 36.5313 23.0105 36.5904 22.9526L39.2131 20.3636L36.5904 17.7409C36.4792 17.6322 36.4141 17.485 36.4083 17.3296C36.4083 17.1508 36.4793 16.9793 36.6058 16.8529C36.7322 16.7264 36.9037 16.6554 37.0825 16.6554C37.2444 16.6574 37.3994 16.7228 37.514 16.8374Z",
    fill: "#0BB7A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_1042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2494,
    height: 22.2494,
    fill: "white",
    transform: "translate(28.3176 8.56467)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrDashboardRejected);
export default __webpack_public_path__ + "static/media/rr_dashboard_rejected.9bd429f9f2dec07e3657e47a76e84c2f.svg";
export { ForwardRef as ReactComponent };